// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from "react-redux";
// import axios from 'axios';
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// import "../assets/css/GroupCenter.css";

// const GroupCenter = () => {
//   const dispatch = useDispatch();
//   const { profile, loading: profileLoading, error } = useSelector((state) => state.userProfile);

//   const [formData, setFormData] = useState({ name: '', location: '' });
//   const [showForm, setShowForm] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [data, setData] = useState([]); // centres list

//   // ✅ Fetch profile when component mounts
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // ✅ Fetch centres after profile is loaded
//   useEffect(() => {
//     const fetchCentres = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/get-centre?branchId=${profile.id}`,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//             },
//           }
//         );
//         console.log("Centres API Response:", res.data);
//         setData(res.data.centres || []);
//       } catch (err) {
//         console.error("Error fetching centres:", err);
//       }
//     };

//     if (profile) {
//       fetchCentres();
//     }
//   }, [profile]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     console.log("BranchId:", profile?.branchId);
//     console.log("SuperAdminId:", profile?.superAdminId);

//     try {
//       if (!profile?.branchId || !profile?.superAdminId) {
//         alert("BranchId or SuperAdminId missing! Please login again.");
//         setLoading(false);
//         return;
//       }

//       const payload = {
//         ...formData,
//         branchId: profile.id,
//         superAdminId: profile.superAdminId,
//       };

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/create-centre`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );

//       alert("Center Created Successfully!");
//       console.log("Response:", response.data);

//       // ✅ Add newly created centre into list
//       setData((prev) => [...prev, response.data.centre || payload]);

//       setShowForm(false);
//       setFormData({ name: '', location: '' });
//     } catch (error) {
//       console.error("Error creating center:", error);
//       alert(error.response?.data?.message || "Failed to create center");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (profileLoading) return <p>Loading profile...</p>;
//   if (error) return <p className="text-red-500">Error: {error}</p>;

//   return (
//     <div className="group-center-2-container">
//       <div className="group-center-2-header-row">
//         <h2><i className="bi bi-people-fill"></i>Collection Landmarks</h2>
//         <button className="group-center-2-create-btn" onClick={() => setShowForm(true)}>
//           Create Center
//         </button>
//       </div>

//       {showForm && (
//         <div className="group-center-2-modal-overlay">
//           <div className="group-center-2-modal-form">
//             <button className="group-center-2-close-btn" onClick={() => setShowForm(false)}>X</button>
//             <form onSubmit={handleSubmit}>
//               <div className="group-center-2-input-box">
//                 <label>Name</label>
//                 <input type="text" name="name" value={formData.name} onChange={handleChange} required />
//               </div>

//               <div className="group-center-2-input-box">
//                 <label>Location</label>
//                 <input type="text" name="location" value={formData.location} onChange={handleChange} required />
//               </div>

//               {/* Debug info */}
//               <p className="text-sm text-gray-500">
//                 BranchId: {profile?.branchId || "N/A"} | SuperAdminId: {profile?.superAdminId || "N/A"}
//               </p>

//               <button type="submit" className="group-center-2-submit-btn" disabled={loading}>
//                 {loading ? "Creating..." : "Submit"}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       <h3 className="group-center-2-section-title"> Center Report</h3>

//       <div className="group-center-2-card-grid">
//         {data.map((item) => (
//           <div className="group-center-2-group-card" key={item.id}>
//             <h4>{item.name}</h4>
//             <p><strong>Location:</strong> {item.location}</p>
//             <p><strong>BranchId:</strong> {item.branchId}</p>
//             <p><strong>SuperAdminId:</strong> {item.superAdminId}</p>
//             <p><strong>Created:</strong> {new Date(item.createdAt).toLocaleString()}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default GroupCenter;

// import React, { useEffect, useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import axios from 'axios';
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import "../assets/css/GroupCenter.css";

// const GroupCenter = () => {
//  const dispatch = useDispatch();
//   const { profile, loading: profileLoading, error } = useSelector((state) => state.userProfile);

//   const [formData, setFormData] = useState({ name: '', location: '' });
//   const [loading, setLoading] = useState(false);
//   const [centerData, setCenterData] = useState([]); // centres list

//   // 🔍 Search + Pagination
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

// // ✅ Fetch profile when component mounts
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // ✅ Fetch centres after profile is loaded
//   useEffect(() => {
//     const fetchCentres = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/get-centre?branchId=${profile.id}`,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//             },
//           }
//         );
//         console.log("Centres API Response:", res.data);
//         setCenterData(res.data.centres || []);
//       } catch (err) {
//         console.error("Error fetching centres:", err);
//       }
//     };

//     if (profile) {
//       fetchCentres();
//     }
//   }, [profile]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     // console.log("BranchId:", profile?.branchId);
//     // console.log("SuperAdminId:", profile?.superAdminId);

//     try {
//       if (!profile?.branchId || !profile?.superAdminId) {
//         alert("BranchId or SuperAdminId missing! Please login again.");
//         setLoading(false);
//         return;
//       }

//       const payload = {
//         ...formData,
//         branchId: profile.id,
//         superAdminId: profile.superAdminId,
//       };

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/create-centre`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );

//       alert("Center Created Successfully!");
//       console.log("Response:", response.data);

//       // ✅ Add newly created centre into list
//       setCenterData((prev) => [...prev, response.data.centre || payload]);
//       setFormData({ name: '', location: '' });
//     } catch (error) {
//       console.error("Error creating center:", error);
//       alert(error.response?.data?.message || "Failed to create center");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // search and filter logic
//   const filteredData = useMemo(() => {
//     let data = [...centerData];

//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     return data;
//   }, [searchQuery, centerData]);

//   // pagination
//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//     if (profileLoading) return <p>Loading profile...</p>;
//   if (error) return <p className="text-red-500">Error: {error}</p>;

//   return (
//     <div className="center-container">
//       <h1 className="center-heading">Center Landmarks</h1>

//       {/* Group Member Creation section */}
//       <div className="center-create-container">
//         <h2>Create Center</h2>
//         <form className="center-create-form" onSubmit={handleSubmit}>
//           <div className="center-create-form-inputs">
//             <div className="center-create-form-group">
//               <label htmlFor="">Center Name</label><br />
//               <input type="text" name="name" value={formData.name} onChange={handleChange}/>
//             </div>
//             <div className="center-create-form-group">
//               <label htmlFor="">Location</label><br />
//               <input type="text" name="location" value={formData.location} onChange={handleChange} />
//             </div>
//             {/* <div className="center-create-form-group">
//               <label htmlFor="">Center Name</label><br />
//               <input type="text" />
//             </div> */}
//           </div>
//           <div className="branch-details">
//             <p>
//               Branch Id: <span>{profile?.branchId}</span>
//             </p>
//             <p>
//               Super Admin Id: <span>{profile?.superAdminId}</span>
//             </p>
//           </div>
//           <button>Create Center</button>
//         </form>
//       </div>

//       {/* Group member report section */}
//       <div className="center-report-container">
//         <h2>Center Report</h2>
//         <div className="center-report-filter">
//           <input
//             type="text"
//             placeholder="Search by any field..."
//             value={searchQuery}
//             onChange={(e) => {
//               setSearchQuery(e.target.value);
//               setCurrentPage(1);
//             }}
//           />

//           <label>
//             Show{" "}
//             <select
//               value={rowsPerPage}
//               onChange={(e) => {
//                 setRowsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value={10}>10</option>
//               <option value={25}>25</option>
//               <option value={50}>50</option>
//               <option value={100}>100</option>
//             </select>{" "}
//             entries
//           </label>
//         </div>

//         {/* Table */}
//         <div className="center-report-section">
//           <table className="center-report-table">
//             <thead>
//               <tr>
//                 <th>S.No.</th>
//                 <th>Center Name</th>
//                 <th>Location</th>
//                 <th>Branch Id</th>
//               <th>Super Admin Id</th>
//               <th>Created At</th>
//               {/* <th>CGT Taken By</th>
//                 <th>Action</th> */}
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((item, index) => (
//                   <tr key={index}>
//                     <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                     <td>{item.name}</td>
//                     <td>{item.location}</td>
//                     <td>{item.branchId}</td>
//                     <td>{item.superAdminId}</td>
//                     <td>{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
//                     {/* <td className="center-report-btns">
//                       <button
//                         className="center-report-edit-btn"
//                         // onClick={() => {
//                         //   setIsModalOpen(true);
//                         //   setSelectedCustomer(row);
//                         // }}
//                         title="Edit" // tooltip on hover
//                       >
//                         <Edit />
//                       </button>

//                       <button
//                         className="center-report-delete-btn"
//                         // onClick={() => openDeleteDialog(row.id)}
//                         title="Delete"
//                       >
//                         <Trash />
//                       </button>
//                     </td> */}
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="10" className="center-report-table-no-records">
//                     ✅ No records found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Pagination */}
//       <div className="center-report-pagination-btns">
//         <button
//           onClick={() => setCurrentPage((p) => p - 1)}
//           disabled={currentPage === 1}
//         >
//           ⬅ Previous
//         </button>

//         <span>
//           Page {currentPage} of {totalPages || 1}
//         </span>

//         <button
//           onClick={() => setCurrentPage((p) => p + 1)}
//           disabled={currentPage === totalPages || totalPages === 0}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default GroupCenter;

import React, { useEffect, useMemo, useState } from "react";
import "../assets/css/GroupCenter.css";
import axios from "axios";
import { Edit, Trash } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";

const GroupCenter = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, "All"];

  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);
  //  console.log("profile data" ,profile);

  // Table Data
  const [centers, setCenters] = useState([]);

  // Form State (Corrected)
  const [formData, setFormData] = useState({
    centerName: "",
    village: "",
    branch: "",
    collectionTime: "",
    collectionDay: "",
    address: "",
    status: "Active",
  });

  useEffect(() => {
    if (profile?.id) {
      fetchCentres();
    }
  }, [profile]);

  const fetchCentres = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}`,
      );
      console.log("response data", res);
      setCenters(res.data.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  // Input Handler
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // console.log(formData);
  };

  // Reset Form
  const resetForm = () => {
    setFormData({
      centerName: "",
      village: "",
      branch: "",
      collectionTime: "",
      collectionDay: "",
      address: "",
      status: "Active",
    });
    setEditIndex(null);
  };

  // Add / Update Handler
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.centerName || !formData.village || !formData.branch) {
      toast.warn("Please fill required fields");
      return;
    }

    if (editIndex !== null) {
      // Update
      const updated = [...centers];
      updated[editIndex] = { ...updated[editIndex], ...formData };
      setCenters(updated);
      toast.success("Updated successfully");
    } else {
      // Create New
      setCenters([...centers, { id: centers.length + 1, ...formData }]);
      toast.success("Center created successfully");
    }

    setModalOpen(false);
    resetForm();
  };

  // Search + Pagination
  const filteredData = useMemo(() => {
    return centers.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()),
    );
  }, [centers, searchQuery]);

  const totalPages =
    itemsPerPage === "All" ? 1 : Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData =
    itemsPerPage === "All"
      ? filteredData
      : filteredData.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage,
        );

  const handledelete = (id) => async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this center?",
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`https://payyug.in/api/group/centre/${id}`);
      toast.success("Center deleted successfully");
      fetchCentres();
    } catch (error) {
      toast.error("Failed to delete center");
    }
  };

  const createUpdate = async (e) => {
    e.preventDefault();
    // if (!profile) {
    //     // toast.error("User profile not loaded yet!");
    //     alert("User profile not loaded yet!");
    //     return;
    // }

    if (!formData.centerName || !formData.village || !formData.collectionDay) {
      toast.warn("Please fill required fields");
      return;
    }
    var payload = {
      CenterName: formData.centerName,
      MeetingTime: formData.collectionTime,
      RecoveryDay: formData.collectionDay,
      SurveyId: 3,
      branchid: Number(profile?.branchId || 6),
      center_leader_id: 12,
      LoanofficerId: Number(profile?.id || 0),
      CenterCode: "CEN101",
      address: formData.address,
      city: formData.village,
      EntryUser: "admin",
      Longitude: "85.153",
      Latitude: "25.594",
      createdby: "admin",
      superAdminId: Number(profile?.superAdminId || 14),
    };

    try {
      if (editIndex !== null) {
        // ===================== UPDATE ======================
        await axios.put(
          `https://payyug.in/api/group/centre/${editIndex}`,
          payload,
        );
        toast.success("Center updated successfully");
      } else {
        // ===================== CREATE ======================
        await axios.post(`https://payyug.in/api/group/centre`, payload);

        toast.success("Center created successfully");
      }

      fetchCentres();
      setModalOpen(false);
    } catch (error) {
      console.log("API Error:", error);
      toast.error(error?.response?.data?.error || "Failed to save");
    }
  };

  return (
    <>
      <div className="center-container">
        <h1 className="center-heading">Center</h1>

        {/* ================= REPORT SECTION ================= */}
        <div className="center-report-container">
          <div className="center-create-filter-section">
            <div className="center-create-section">
              <h1>Collection Center List</h1>

              <button
                className="add-btn"
                onClick={() => {
                  resetForm();
                  setModalOpen(true);
                }}
              >
                Add New
              </button>
            </div>

            <div className="center-report-filter-div">
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />

              <div className="center-filter">
                <label>Show </label>
                <select
                  onChange={(e) => {
                    const value = e.target.value;

                    setItemsPerPage(value === "All" ? "All" : Number(value));

                    setCurrentPage(1);
                  }}
                  value={itemsPerPage}
                >
                  {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </select>
                <span> entries</span>
              </div>
            </div>
          </div>

          {/* Report Table section */}
          <div className="center-report-table-container">
            <table className="center-report-table">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Center Name</th>
                  <th>Center Code</th>
                  <th>City/Village</th>
                  <th>Branch</th>
                  <th>Collection Day</th>

                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item, index) => (
                    <tr key={item.id}>
                      <td>
                        {" "}
                        {itemsPerPage === "All"
                          ? index + 1
                          : (currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td>{item.CenterName}</td>
                      <td>{item.CenterCode}</td>
                      <td>{item.city}</td>
                      <td>{item.branchid}</td>
                      <td>{item.RecoveryDay}</td>

                      <td className="group-center-action-button">
                        <Edit
                          className="edit-icon"
                          onClick={() => {
                            setEditIndex(item.id);
                            setFormData({
                              centerName: item.CenterName,
                              village: item.city,
                              collectionTime: item.MeetingTime,
                              collectionDay: item.RecoveryDay,
                              address: item.address,
                              status: item.status || "Active",
                            });
                            setModalOpen(true);
                          }}
                        />
                        <Trash
                          className="delete-icon"
                          onClick={handledelete(item.id)}
                        >
                          {" "}
                        </Trash>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {itemsPerPage !== "All" && filteredData.length > itemsPerPage && (
            <div className="center-pagination-div">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                ⬅ Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next ➡
              </button>
            </div>
          )}
        </div>

        {/* Modal */}
        {modalOpen && (
          <div className="center-dialog-overlay">
            <div className="center-dialog-box">
              <h2 className="center-dialog-box-heading">
                {editIndex !== null ? "Edit Center" : "Add New Center"}
              </h2>

              <form
                className="center-dialog-box-form-section"
                onSubmit={createUpdate}
              >
                <div className="center-dialog-box-form-grid">
                  <div className="center-dialog-box-input-group">
                    <label>Center Name</label>
                    <input
                      type="text"
                      name="centerName"
                      value={formData.centerName}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="center-dialog-box-input-group">
                    <label>City/Village Name</label>
                    <input
                      type="text"
                      name="village"
                      value={formData.village}
                      onChange={handleChange}
                      // readOnly={editIndex !== null}
                    />
                  </div>

                  {/* <div className="center-dialog-box-input-group">
                    <label>Branch</label>
                    <input
                      type="text"
                      name="branch"
                      value={formData.branch}
                      onChange={handleChange}
                    />
                  </div> */}

                  <div className="center-dialog-box-input-group">
                    <label>Collection Time</label>
                    <input
                      type="time"
                      name="collectionTime"
                      value={formData.collectionTime}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="center-dialog-box-input-group">
                    <label>Select Collection Day</label>
                    <select
                      name="collectionDay"
                      value={formData.collectionDay}
                      onChange={handleChange}
                    >
                      <option value=""></option>
                      <option value="Monday">Monday</option>
                      <option value="Tuesday">Tuesday</option>
                      <option value="Wednesday">Wednesday</option>
                      <option value="Thursday">Thursday</option>
                      <option value="Friday">Friday</option>
                      <option value="Saturday">Saturday</option>
                      <option value="Sunday">Sunday</option>
                    </select>
                  </div>

                  <div className="center-dialog-box-input-group">
                    <label>Address</label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      // readOnly={editIndex !== null}
                    />
                  </div>

                  {/* <div className="center-dialog-box-input-group">
                    <label>Center Status</label>
                    <div>
                      <input
                        type="radio"
                        name="status"
                        value="Active"
                        checked={formData.status === "Active"}
                        onChange={handleChange}
                      />{" "}
                      ✔Active
                      <input
                        type="radio"
                        name="status"
                        style={{marginLeft:"10px"}}
                        value="Inactive"
                        checked={formData.status === "Inactive"}
                        onChange={handleChange}
                      />{" "}
                      ❌Inactive
                    </div>
                  </div> */}
                </div>

                <div className="center-dialog-btns">
                  <button type="submit">
                    {editIndex !== null ? "Update" : "Create"}
                  </button>

                  <button type="button" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>
                  <button type="button" onClick={resetForm}>
                    Reset
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default GroupCenter;
